import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_kqgwsb5nt7: FaireBrandEntity = {
  token: "b_kqgwsb5nt7",
  type: "brand",
  name: "Roost Naturals",
  avatarUrl:
    "https://cdn.faire.com/fastly/9cbd76b24c71df02d9e5d918ba40c0b931114379b3c58c5e1fcf943757cb44d0.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/d72153ce81630a53420ac643e35539311b7332ee94f7b84d3407b9cab52b655f.png",
  logoUrl:
    "https://cdn.faire.com/fastly/9cbd76b24c71df02d9e5d918ba40c0b931114379b3c58c5e1fcf943757cb44d0.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/d72153ce81630a53420ac643e35539311b7332ee94f7b84d3407b9cab52b655f.png",
  location: "Long Grove, IA, USA",
  minimumOrderDollars: 150,
  rating: 5,
  reviewCount: 3,
  isInsider: true,
  description:
    "Roost Naturals was founded by Cassandra, a mother of five with a deep passion for taking back health and creating a home free of toxins. What began as a personal mission to rid her household of harmful, chemical-filled products quickly grew into a journey of returning to nature’s simplicity.\n\nDriven by the desire to care for her family with safe, effective alternatives, Cassandra began crafting products made from clean, natural ingredients. But she also believed that “natural” shouldn’t mean sacrificing beauty or enjoyment. Each product she created not only worked, but also smelled wonderful and felt like a small daily ritual of care.\n\nRoost Naturals is the result of her commitment to wellness, family, and the belief that what we put on our bodies and bring into our homes matters. Every product is made with the same intention and love that first inspired her—to help others embrace a more natural, balanced, and nourishing way of life.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:46:08.747Z",
    importedBy: "entity-db-cli",
  },
};
